<template>
  <p class="free-episode">
    LISTEN FREE
  </p>
</template>

<script>
export default {
  props: {
    absolute: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/variables.scss';

.free-episode {
  background-color: #F9CACA;
  color: $black;
  font-size: 10px;
  padding: 3px 6px;
  display: inline-block;
  margin: 0;
  line-height: 12px;
}
</style>



// WEBPACK FOOTER //
// app/src/components/FreeEpisodeIndicator.vue